export const defaultAboutInfoTemplate = {
  name: "柳叶仙",
  avatar: "/src/assets/logo.jpg",
  intro: "这个人很神秘，什么也没留下。",
  details: "欢迎来到我的博客！请登陆后完善您的个人信息！",
  email: "未设置邮箱",
  techStack: "暂无",
  interests: "暂无",
  github: "#",
  linkedin: "#",
  personalHomepage: "#",
};

export const defaultPosts = [
  {
    id: "1",
    title: "皮炎可松",
    summary: "横扫法租界驰名中外，号称从未输过的法国赌神",
    content:
      "给我擦皮鞋\n我要验牌\n牌没有问题\n小儿科\n小瘪三",
    date: "2025-12-22",
    tags: ["React", "Antd", "Blog"],
  },
];

